import React, {Component} from 'react';
import '../../style.css';
import {Button, Input, message, PageHeader, Space, Typography, Card, Modal} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;

class StaffSituation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            aveNum: '',
            insNum: '',
            partTimeNum: '',
            temNum: '',
            allNum: '',
            description: "",
            status:false,
            fileStream:'',
            preview_visible:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount(){
        //获取公司的人员情况
        fetchPost(global.constants.getStaffSituationGetK,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            aveNum: res.data.aveNum,
                            insNum: res.data.insNum,
                            partTimeNum: res.data.partTimeNum,
                            temNum: res.data.temNum,
                            allNum: res.data.allNum,
                            description: res.data.description,
                            companyName: res.data.companyName,
                            companyId:res.data.companyId,
                            status:true,
                        }))
                    }
                }
            )
    }
    submit(){
        if(this.state.aveNum === ''||this.state.insNum === ''||this.state.partTimeNum === ''||
            this.state.temNum === ''||this.state.allNum === ''||this.state.description === ''){
            message.info("请检查人员信息是否填写完整").then()
        }else{
            let params = {
                aveNum: this.state.aveNum,
                insNum: this.state.insNum,
                partTimeNum: this.state.partTimeNum,
                temNum: this.state.temNum,
                allNum: this.state.allNum,
                description: this.state.description,
                companyName: this.state.companyName,
                companyId: this.state.companyId
            }
            fetchPost(global.constants.updateStaffSituationK, params)
                .then(
                    res=> {
                        if (res.code === 200) {
                            message.success("添加成功！").then()
                            fetchPost(global.constants.getStaffSituationGetK,{companyId: this.state.companyId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                aveNum: res.data.aveNum,
                                                insNum: res.data.insNum,
                                                partTimeNum: res.data.partTimeNum,
                                                temNum: res.data.temNum,
                                                allNum: res.data.allNum,
                                                description: res.data.description,
                                                companyName: res.data.companyName,
                                                companyId:res.data.companyId,
                                                status:true,
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    edit(){
        this.setState(()=>({
            status:false
        }))
    }
    handleExportClick(){
        fetchPost(global.constants.exportStaffSituationK, {companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-16人员情况表.doc',
            fileName: '人员情况表.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-16人员情况表.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-16人员情况表.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/人员情况表.pdf',
                            fileName: '人员情况表.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="企业职工人数情况表"
                        extra={[
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Button
                                type="primary"
                                onClick={this.handlePreviewClick.bind(this)}
                            >预览</Button>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style">
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                    <Typography >
                        <div className='word'>
                            <Paragraph className='word-title'>{this.state.companyName}企业职工人数情况表</Paragraph>
                        </div>
                        <Paragraph>
                            <div className="left-word">企业名称：{this.state.companyName}
                                <div className="right-word">单位：人</div>
                            </div>
                        </Paragraph>
                    <table border="1" className='table'>
                        <tr>
                            <td height="60;" colSpan="1" width="10%">全年月平均在职人员数①
                            </td>
                            <td colSpan="2"  width="40%">{
                                this.state.status === false?
                                    <Input className="input_style"
                                           defaultValue={this.state.aveNum}
                                           onChange={this.aveNumChange.bind(this)}/>:
                                    this.state.aveNum
                            }
                            </td>
                            <td height="60;" colSpan="1"  width="10%">其中：参保人员数</td>
                            <td height="60;" colSpan="2"  width="40%">
                                {
                                     this.state.status === false?
                                        <Input className="input_style"
                                               defaultValue={this.state.insNum}
                                               onChange={this.insNumChange.bind(this)}/>:
                                        this.state.insNum
                                }
                            </td>
                        </tr>
                        <tr>
                            <td height="60;" colSpan="1">工作时间超过183天的兼职人员数②</td>
                            <td colSpan="5">
                                {
                                     this.state.status === false?
                                        <Input className="input_style"
                                               defaultValue={this.state.partTimeNum}
                                               onChange={this.partTimeNumChange.bind(this)}/>:
                                        this.state.partTimeNum
                                }
                            </td>
                        </tr>
                        <tr>
                            <td height="60;" colSpan="1" >工作时间超过183天的临时聘用人员数③</td>
                            <td colSpan="5">
                                {
                                    this.state.status === false?
                                        <Input className="input_style"
                                               defaultValue={this.state.temNum}
                                               onChange={this.temNumChange.bind(this)}/>:
                                        this.state.temNum
                                }
                            </td>
                        </tr>
                        <tr>
                            <td height="60;" colSpan="1" >企业职工总数（①+②+③）</td>
                            <td colSpan="5">
                                {
                                   this.state.status === false?
                                        <Input className="input_style"
                                               defaultValue={this.state.allNum}
                                               onChange={this.allNumChange.bind(this)}/>:
                                        this.state.allNum
                                }
                            </td>
                        </tr>
                        <tr>
                            <td height="60;" colSpan="1" >全年月平均在职人员数与参保人数差异的情况说明</td>
                            <td colSpan="5">{
                                 this.state.status === false?
                                    <Input className="input_style"
                                           defaultValue={this.state.description}
                                           onChange={this.descriptionChange.bind(this)}/>:
                                    this.state.description
                            }</td>
                        </tr>
                    </table>
                    <div className="left-word">注：申报材料中人力资源情况表相关数据须与本表中企业职工总数一致</div>
                    </Typography>
                    <div>
                        <Button type="primary" className="upload-button" onClick={this.submit.bind(this)}>提交</Button>
                        <Button
                            disabled={!this.state.status}
                            type="primary" className="upload-button" onClick={this.edit.bind(this)}>编辑</Button>
                    </div>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'50%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                                onError={this.onError}
                    />
                </Modal>
            </div>
        )
    }
    descriptionChange(e){
        const value = e.target.value
        this.setState(()=>({
            description:value
        }))
    }
    aveNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            aveNum:value
        }))
    }
    insNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            insNum:value
        }))
    }
    partTimeNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            partTimeNum:value
        }))
    }
    temNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            temNum:value
        }))
    }
    allNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            allNum:value
        }))
    }
}

export default StaffSituation;